import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  not_available: 'Not Available',
  maintenance_needed: 'Maintenance',
  ready_for_use: 'Ready To Use',
  in_custody: 'In Custody',
  inspection_needed: 'Inspection Needed',
  out_of_commission: 'Out Of Commission',
  missing: 'Missing',
  pending_hse_approval: 'Pending HSE Approval',
};

const statusColors: Record<string, string> = {
  not_available: '#000000',
  maintenance_needed: '#F04F0F',
  ready_for_use: '#5F9A7E',
  in_custody: '#448AFF',
  inspection_needed: '#8B8000',
  out_of_commission: '#8F00FF',
  missing: '#B01F0F',
  pending_hse_approval: '#53687A',
};

@Pipe({
  name: 'assetStatus',
})
export class AssetStatusPipe implements PipeTransform {
  public transform(value: string, color: boolean): string {
    if (color) {
      return statusColors[value];
    } else {
      return statuses[value];
    }
  }

  get statuses() {
    let statusesWithColor = [];
    Object.keys(statuses).forEach((status) => {
      statusesWithColor = [...statusesWithColor, { name: statuses[status], color: statusColors[status], key: status }];
    });
    return statusesWithColor;
  }

  get statusesButMissing() {
    let statusesWithColor = [];
    Object.keys(statuses).forEach((status) => {
      if (status !== 'missing') {
        statusesWithColor = [
          ...statusesWithColor,
          { name: statuses[status], color: statusColors[status], key: status },
        ];
      }
    });
    return statusesWithColor;
  }

  get statusWithColor() {
    let statusesWithColor = [];
    Object.keys(statuses).forEach((status) => {
      statusesWithColor = [...statusesWithColor, status, statusColors[status]];
    });
    return statusesWithColor;
  }
}
